const checklistItems = [
  "One soft armchair",
  "One warm floor lamp",
  "One small wood side table",
  "A few stacked books",
  "One linen or knit throw",
  "One textured cushion",
  "One woven rug",
  "One ceramic decor piece",
  "One small plant or branch",
];

export default function RCArticleFormula() {
  return (
    <section className="max-w-2xl mx-auto px-4 md:px-0 py-4">
      {/* Visual formula checklist */}
      <div className="bg-[#FAF7F0] rounded-2xl p-8 md:p-12 mb-14">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-5"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Visual Reference
        </p>
        <h2
          className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-8"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          A simple formula for a cozy neutral reading corner
        </h2>
        <ul className="space-y-4">
          {checklistItems.map((item, i) => (
            <li key={i} className="flex items-center gap-4">
              <span
                className="w-6 h-6 flex items-center justify-center rounded-full border border-[#C8BAA8] text-[#B5A898] flex-shrink-0"
                style={{ fontFamily: "'Inter', sans-serif", fontSize: "10px" }}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <span
                className="text-[#4A3F38] text-sm"
                style={{ fontFamily: "'Inter', sans-serif", fontWeight: 400 }}
              >
                {item}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Final thoughts */}
      <div className="pb-16 border-b border-[#EDE6DA]">
        <h2
          className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-5"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          Final thoughts
        </h2>
        <p
          className="text-[#6B5E53] text-base leading-[1.9]"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
        >
          A cozy reading corner does not need much space, a large budget, or dramatic styling to feel beautiful and personal. Soft seating, warm light, natural textures, and a quiet neutral palette are genuinely enough. The real work is in the editing — choosing fewer things, placing them with care, and resisting the urge to add more. Start with a chair you love in a spot where the light feels gentle, and build slowly from there. A great reading corner takes care of itself.
        </p>
      </div>
    </section>
  );
}
